export const REFERRAL_ID_QUERY_PARAM = 'ref';

const REFERRAL_ID_STORAGE_KEY = 'grato.auth.ref_id';

function canUseLocalStorage() {
  return (
    typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
  );
}

function parseReferralAttributionId(value: string | null): number | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();

  if (!/^\d+$/.test(trimmedValue)) {
    return null;
  }

  const referrerId = Number(trimmedValue);

  if (!Number.isSafeInteger(referrerId) || referrerId < 1) {
    return null;
  }

  return referrerId;
}

export function resolveReferralAttributionIdFromSearch(
  search: string,
): number | null | undefined {
  const referrerId = new URLSearchParams(search).get(REFERRAL_ID_QUERY_PARAM);

  if (referrerId === null) {
    return undefined;
  }

  return parseReferralAttributionId(referrerId);
}

export function readReferralAttributionId(): number | null {
  if (!canUseLocalStorage()) {
    return null;
  }

  try {
    return parseReferralAttributionId(
      window.localStorage.getItem(REFERRAL_ID_STORAGE_KEY),
    );
  } catch {
    return null;
  }
}

export function writeReferralAttributionId(referrerId: number): void {
  if (!canUseLocalStorage()) {
    return;
  }

  if (!Number.isSafeInteger(referrerId) || referrerId < 1) {
    clearReferralAttributionId();
    return;
  }

  try {
    window.localStorage.setItem(REFERRAL_ID_STORAGE_KEY, String(referrerId));
  } catch {
    // localStorage can be blocked in privacy mode.
  }
}

export function clearReferralAttributionId(): void {
  if (!canUseLocalStorage()) {
    return;
  }

  try {
    window.localStorage.removeItem(REFERRAL_ID_STORAGE_KEY);
  } catch {
    // localStorage can be blocked in privacy mode.
  }
}
